import { useContext } from 'react';

// auth provider
import AuthContext from 'contexts/AzureB2CContext';

// ==============================|| AUTH HOOKS ||============================== //

export default function useAuth() {
  const context = useContext(AuthContext);

  if (!context) throw new Error('context must be used inside provider');

  return context;
}
